<template>
  <div class="calendarPage">
    <CalendarWrapper />
  </div>
</template>

<script>

import CalendarWrapper from '@/components/calendar/CalendarWrapper'

export default {
  name: 'Calendar',
  components: {
    'CalendarWrapper': CalendarWrapper
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Calendar.vue